import { styled } from '@spazious/dollhouse-theme';

import { Flex } from '../Flex/index.js';

export const DialogHeader = styled(Flex).withConfig({
  displayName: 'DialogHeader',
})`
  padding: 16px 24px;
  flex: 0 0 auto;
`;
